import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

import { SUPABASE_URL, SUPABASE_ANON_KEY, SUPABASE_LOCAL_STORAGE_KEY, IS_DEMO_MODE } from "@/config/config";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  // The demo has no accounts: it never reads, keeps or refreshes a session.
  auth: {
    autoRefreshToken: !IS_DEMO_MODE,
    persistSession: !IS_DEMO_MODE,
    detectSessionInUrl: !IS_DEMO_MODE,
  },
  db: {
    // The demo schema mirrors public table for table, so the public types still apply.
    schema: (IS_DEMO_MODE ? 'demo' : 'public') as 'public'
  },
  global: {
    headers: {
      'x-application': 'housingfirst'
    },
    // Add fetch configuration for better serverless compatibility
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        // Add timeout to prevent hanging requests in serverless
        signal: AbortSignal.timeout(30000) // 30 second timeout
      })
    }
  }
}) 